import { render, staticRenderFns } from "./plog.vue?vue&type=template&id=3182a35a&scoped=true&"
import script from "./plog.vue?vue&type=script&lang=js&"
export * from "./plog.vue?vue&type=script&lang=js&"
import style0 from "./plog.vue?vue&type=style&index=0&id=3182a35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182a35a",
  null
  
)

export default component.exports